import type { Routes } from '@angular/router';
import { OnyxFormMode } from '@onyx/angular';
import type { FormResolverData } from '../../common/interfaces/common/form-resolver-data';
import { importGuard } from '../common/guards/import.guard';
import { DRIVERS_IMPORT_COLUMNS } from './common/constants/drivers-import-columns';
import type { DriverForm } from './common/helpers/driver-form.helper';
import { addDriverResolver } from './common/resolvers/add-driver.resolver';
import { driverCardResolver } from './common/resolvers/driver-card.resolver';
import { editDriverResolver } from './common/resolvers/edit-driver.resolver';
import { importDriversResolver } from './common/resolvers/import-drivers.resolver';

export type DriverFormResolverData = FormResolverData<DriverForm>;

export const DRIVERS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./drivers-list/drivers-list.component').then(
        (m) => m.DriversListComponent,
      ),
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./driver-form/driver-form.component').then(
        (m) => m.DriverFormComponent,
      ),
    data: { mode: OnyxFormMode.ADD },
    resolve: { data: addDriverResolver },
  },
  {
    path: 'import',
    loadComponent: () =>
      import('../common/components/import/import-result/import-result.component').then(
        (m) => m.ImportResultComponent,
      ),
    canActivate: [importGuard],
    data: { columns: DRIVERS_IMPORT_COLUMNS },
    resolve: { import: importDriversResolver },
  },
  {
    path: ':uuid',
    children: [],
    resolve: { _: driverCardResolver },
  },
  {
    path: ':uuid/edit',
    loadComponent: () =>
      import('./driver-form/driver-form.component').then(
        (m) => m.DriverFormComponent,
      ),
    data: { mode: OnyxFormMode.EDIT },
    resolve: { data: editDriverResolver },
  },
] as const;
